import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import HTMLFlipBook from "react-pageflip";

import Logo192 from "../../../../assets/abLargeGoldenLogo.png";
import Page01, {
  ConceptualPage01,
  LogoPlacement,
  RenderPage01,
  SitePage01,
} from "../../materialDesign/pdfPages/Page01";
import abWatermark from "../../../../assets/abWatermark.png";
import ImgGrid from "./ConcepMoodBoard/ImgGrid";
import {
  convertDataFormat,
  getBase64ImageFromUrl,
  getDesignBgImage,
  getFlipbookHeight,
  getGoogleFormData,
  getImageUrls,
  getMinioImage,
  getMoodboardArray,
  getOptimizedAssets,
} from "../../../../utils/helpers";
import ThreeDPanel from "./Components/ThreeDPanel";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import intro from "../../../../assets/introPage.jpeg";
import { Box, Button, IconButton, Text, VStack } from "@chakra-ui/react";
import ViewPageSite from "./SiteFeasibility/ViewPageSite";
import siteIntro from "../../../../assets/SFR.jpeg";
import renderIntro from "../../../../assets/renderIntro.png";
import conceptualIntro from "../../../../assets/conceptualIntro.jpg";
import pageFlipSound from "../../../../assets/pageFlip.mp3";
import watermark from "../../../../assets/water.png";
import AbLogo from "../../../../assets/logo192.png";

import axios from "axios";
import { designStyle } from "../../../../utils/options";
import OutroImage from "../../../../components/OutroImage";
import flipbookImages from "../../../../assets/flipbook";
// import AbLogo from "../../../../assets/logo192.png";

import introPage from "../../../../assets/introPage.jpeg";
import Img from "../../../../components/Img";
import TopAbLogo from "./TopAbLogo";
import ShareButton from "../../../../components/ShareButton";
import { Icon } from "@iconify/react/dist/iconify.js";
import useWidth from "../../../../utils/useWidth";
import Loader from "../../../../components/Loader";
import layout from "../../../../assets/flipbook/layout.jpg";
import layoutBg from "../../../../assets/flipbook/LayoutBg.png";
import renderHeadingSlide from "../../../../assets/renderHeading2.jpg";
// import  layout from "../../../../assets/ layoutSlide.jpg";
// import  layoutBG from "../../../../assets/ layoutSlideBg.jpg";

import BG from "../../../../assets/3dBg.png";
// import flipbookImagesMob from "../../../../assets/flipbook/mobile";
// import flipbookImagesTab from "../../../../assets/flipbook/tablet";
import moment from "moment";
import Disclamer from "./Disclamer";
// import { flipbookExtraLarge } from "../../../../assets/flipbook/extraLarge";
import CroppedImageFromFile from "../../../../components/formComponents/CroppedImage";
import FormPages from "./SiteFeasibility/FormPages";
import classNames from "classnames";
import ImgOptimized from "../../../../components/ImgOptimized";
import LayoutSlide from "./LayoutSlide";

// import { opacity } from "html2canvas/dist/types/css/property-descriptors/opacity";

const PublicViewRender = ({
  testView,
  presentationType,
  maxW,
  testName,
  isTestView = false,
}) => {
  let { state } = useLocation();
  state = testView ? { data: testView } : state;
  let { id, type, projectName } = useParams();
  projectName = testName ? testName : projectName;
  id = testView ? "testing" : id;
  const [loading, setLoading] = useState(false);
  let [viewData, setViewData] = useState(
    state?.data
      ? {
          ...state?.data,
          selection1:
            state?.data?.selection1 &&
            typeof state?.data?.selection1 == "string"
              ? JSON.parse(state?.data?.selection1)
              : state?.data?.selection1
                ? state?.data?.selection1
                : {},
          selection2:
            state?.data?.selection2 &&
            typeof state?.data?.selection2 == "string"
              ? JSON.parse(state?.data?.selection2)
              : state?.data?.selection2
                ? state?.data?.selection2
                : {},
          selection3:
            state?.data?.selection3 &&
            typeof state?.data?.selection3 == "string"
              ? JSON.parse(state?.data?.selection3)
              : state?.data?.selection3
                ? state?.data?.selection3
                : {},
          selection4:
            state?.data?.selection4 &&
            typeof state?.data?.selection4 == "string"
              ? JSON.parse(state?.data?.selection4)
              : state?.data?.selection4
                ? state?.data?.selection4
                : {},
        }
      : {},
  );
  const ref = React.useRef();
  const nav = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const IS_INTERNAL = searchParams.get("type") === "internal";
  if (type == "sf") type = "site";
  if (type == "cm") type = "conceptual";
  if (type == "tr") type = "render";

  type = presentationType ? presentationType : type;

  const [linkExp, setLinkExp] = useState(false);
  const [loader, setLoader] = useState(!testView);
  const [pdfPages, setPdfPages] = useState({
    currentPage: 0,
    totalPage: 1,
  });
  const { pathname } = useLocation();
  // console.log("PublicViewRender data", state?.data, type, IS_INTERNAL);

  // const width = useWidth();
  const flipBookRef = React.useRef();
  const [containerWidth, setContainerWidth] = useState(window.innerWidth);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [flipBookPosition, setFlipBookPosition] = useState({
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: 0,
    height: 0,
  });
  const [skipButtonPosition, setSkipButtonPosition] = useState({
    top: -100,
    right: 20,
  });
  const audioRef = useRef();
  const beforeImgs = flipbookImages
    .filter((_, i) => i < 5)
    .map((_, i) =>
      getOptimizedAssets([
        flipbookImages[i],
        flipbookImages[i],
        flipbookImages[i],
        flipbookImages[i],
      ]),
    );
  const afterImgs = flipbookImages
    .filter((_, i) => i >= 5)
    .map((_, i) =>
      getOptimizedAssets([
        flipbookImages[i + 5],
        flipbookImages[i + 5],

        flipbookImages[i + 5],
        flipbookImages[i + 5],
      ]),
    );
  useEffect(() => {
    audioRef.current = new window.Audio(pageFlipSound);
  }, []);

  const handlePageFlip = (e) => {
    if (audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.play();
    }
    // Update current page index
    if (e && typeof e.data === "object" && typeof e.data.page === "number") {
      setCurrentPage(e.data.page);
    }
  };

  // const handleDownload = async () => {
  //   // add watermark in everypage
  //   // watermark is image imported as abWatermark
  //   const elementNodeList = document.getElementsByClassName("pdfSection");
  //   const elements = Array.from(elementNodeList);
  //   if (elements.length === 0) {
  //     console.error("No elements found");
  //     return;
  //   }
  //   setLoading(true);
  //   const pdfWidth = 896;
  //   const pdfHeight = 504;

  //   const pdf = new jsPDF({
  //     orientation: "landscape",
  //     unit: "px",
  //     format: [pdfWidth, pdfHeight],

  //   });

  //   for (let i = 0; i < elements.length; i++) {
  //     const element = elements[i];

  //     // Force the element to be rendered exactly as per PDF size
  //     element.style.display = "block";
  //     element.style.position = "relative";
  //     element.style.left = "0px";
  //     element.style.width = `${pdfWidth}px`;
  //     element.style.height = `${pdfHeight}px`;

  //     const canvas = await html2canvas(element, {
  //       scale: 1, // No extra scaling
  //       width: pdfWidth,
  //       height: pdfHeight,
  //     });

  //     const imgData = canvas.toDataURL("image/png");

  //     if (i > 0) pdf.addPage();
  //     pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

  //     const watermarkWidth = 400; // Adjust watermark size as needed
  //     const watermarkHeight = 200;
  //     const watermarkX = (pdfWidth - watermarkWidth) / 2; // Center horizontally
  //     const watermarkY = (pdfHeight - watermarkHeight) / 2; // Center vertically

  //     // pdf.addImage(
  //     //   abWatermark,
  //     //   "PNG",
  //     //   watermarkX,
  //     //   watermarkY,
  //     //   watermarkWidth,
  //     //   watermarkHeight
  //     // );
  //   }

  //   pdf.save("my-document.pdf");
  //   setLoading(false);
  // };
  //   const handleDownload = async () => {
  //     // add watermark in everypage
  //     // watermark is image imported as abWatermark
  //     const elementNodeList = document.getElementsByClassName("pdfSection");
  //     const elements = Array.from(elementNodeList);
  //     if (elements.length === 0) {
  //       console.error("No elements found");
  //       return;
  //     }
  //     setLoading(true);
  //     const pdfWidth = 896;
  //     const pdfHeight = 504;

  //     const pdf = new jsPDF({
  //       orientation: "landscape",
  //       unit: "px",
  //       format: [pdfWidth, pdfHeight],
  //     });
  //     setPdfPages(p=> ({...p, totalPage: elements.length}))

  //     for (let i = 0; i < elements.length; i++) {
  //       const element = elements[i];
  //       setPdfPages(p=> ({...p, currentPage: i+1}))

  //       // console.log("ELEMENT OF PDF ",i ,  " TOTAL ELEMETS ",elements.length , " OUTER HTML ", element?.outerHTML)

  //       // Force the element to be rendered exactly as per PDF size
  //       // element.style.lineHeight = "1.5"; // or whatever your design uses
  // element.style.boxSizing = "border-box";
  // // element.style.transform = "none";
  // // element.style.position = "relative";
  //       element.style.display = "block";
  //       element.style.position = "relative";
  //       element.style.left = "0px";
  //       element.style.width = `${pdfWidth}px`;
  //       element.style.height = `${pdfHeight}px`;

  //       // ✅ Increase scale for sharper render, but keep final size same
  //       const canvas = await html2canvas(element, {
  //         scale: 2, // boost sharpness
  //         width: pdfWidth,
  //         height: pdfHeight,
  //           useCORS: true,  // ✅ Add this
  //   allowTaint: true, // ✅ Add this
  //   letterRendering: true, // ✅ Better text rendering
  //       });

  //       const imgData = canvas.toDataURL("image/png", 1.0);

  //       if (i > 0) pdf.addPage();
  //       // ✅ Still use fixed pdfWidth & pdfHeight (no change in dimensions)
  //       pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

  //       const watermarkWidth = 400; // Adjust watermark size as needed
  //       const watermarkHeight = 200;
  //       const watermarkX = (pdfWidth - watermarkWidth) / 2; // Center horizontally
  //       const watermarkY = (pdfHeight - watermarkHeight) / 2; // Center vertically

  //       // pdf.addImage(
  //       //   abWatermark,
  //       //   "PNG",
  //       //   watermarkX,
  //       //   watermarkY,
  //       //   watermarkWidth,
  //       //   watermarkHeight
  //       // );

  //     }

  //     pdf.save(
  //       pathname?.includes("/conceptual" || "/cm")
  //         ? "Conceptual Moodboard by AirBrick.pdf"
  //         : pathname?.includes("/site" || "/sf")
  //         ? "Site Feasibility by AirBrick.pdf"
  //         : "3D Render by AirBrick.pdf"
  //     );
  //     setLoading(false);
  //   };
  const handleDownload = async () => {
    const elementNodeList = document.getElementsByClassName("pdfSection");
    const elements = Array.from(elementNodeList);

    if (elements.length === 0) {
      console.error("No elements found");
      return;
    }

    setLoading(true);

    const pdfWidth = 896;
    const pdfHeight = 504;
    const pdf = new jsPDF({
      orientation: "landscape",
      unit: "px",
      format: [pdfWidth, pdfHeight],
    });

    // ✅ Wait for fonts to load
    await document.fonts.ready;

    setPdfPages((p) => ({ ...p, totalPage: elements.length }));

    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];

      setPdfPages((p) => ({ ...p, currentPage: i + 1 }));
      await new Promise((resolve) => setTimeout(resolve, 50));

      // console.log("ELEMENT OF PDF ", i, " TOTAL ELEMENTS ", elements.length);

      // Force the element to be rendered exactly as per PDF size
      element.style.display = "block";
      element.style.position = "relative";
      element.style.left = "0px";

      element.style.width = `${pdfWidth}px`;
      element.style.height = `${pdfHeight}px`;

      // ✅ Extract all <a> tags and their positions BEFORE rendering canvas
      const links = [];
      const anchorTags = element.querySelectorAll("a[href]");

      anchorTags.forEach((anchor) => {
        const rect = anchor.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();

        // Calculate position relative to the element
        const x = rect.left - elementRect.left;
        const y = rect.top - elementRect.top;
        const width = rect.width;
        const height = rect.height;

        links.push({
          url: anchor.href,
          x: x,
          y: y,
          width: width,
          height: height,
        });
      });

      // Increase scale for sharper render
      const canvas = await html2canvas(element, {
        scale: 3,
        width: pdfWidth,
        height: pdfHeight,
        useCORS: true,
        allowTaint: true,
        letterRendering: true,
      });

      const imgData = canvas.toDataURL("image/png", 2.0);

      if (i > 0) pdf.addPage();

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

      // ✅ Add clickable links to PDF
      links.forEach((link) => {
        pdf.link(link.x, link.y, link.width, link.height, { url: link.url });
      });

      // Watermark code (commented out)
      const watermarkWidth = 400;
      const watermarkHeight = 200;
      const watermarkX = (pdfWidth - watermarkWidth) / 2;
      const watermarkY = (pdfHeight - watermarkHeight) / 2;

      // pdf.addImage(
      //   abWatermark,
      //   "PNG",
      //   watermarkX,
      //   watermarkY,
      //   watermarkWidth,
      //   watermarkHeight
      // );
    }

    pdf.save(
      pathname?.includes("/conceptual" || "/cm")
        ? "Conceptual Moodboard by AirBrick.pdf"
        : pathname?.includes("/site" || "/sf")
          ? "Site Feasibility by AirBrick.pdf"
          : "3D Render by AirBrick.pdf",
    );

    setLoading(false);
  };

  useEffect(() => {
    const updateWidth = () => {
      if (ref?.current) {
        // ref.current.clientWidth<640 ?        setContainerWidth(ref.current.clientHeight) :
        setContainerWidth(
          testView
            ? Math.min(ref?.current?.clientWidth, maxW)
            : ref.current.clientWidth,
        );
      }
    };

    updateWidth();
    window.addEventListener("resize", updateWidth);

    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  const goToNextPage = () => {
    handlePageFlip();
    setCurrentPage((prev) => prev + 1);
    flipBookRef.current?.pageFlip()?.flipNext("top");
  };

  const goToPrevPage = () => {
    handlePageFlip();
    setCurrentPage((prev) => prev - 1);
    flipBookRef.current?.pageFlip()?.flipPrev("top");
  };
  const handleSkipContent = () => {
    if (flipBookRef?.current && currentPage != 6) {
      flipBookRef?.current?.pageFlip()?.flip(6);
      setCurrentPage(6);
      if (audioRef.current) {
        audioRef.current.currentTime = 0;
        audioRef.current.play();
      }
    }
  };

  // Update flipbook position
  useEffect(() => {
    const updatePosition = () => {
      if (!flipBookRef.current?.pageFlip) return;
      const rect = flipBookRef.current.pageFlip()?.getBoundsRect();
      if (rect) {
        setFlipBookPosition({
          top: rect.top,
          left: rect.left,
          right: rect.right,
          bottom: rect.bottom,
          width: rect.width,
          height: rect.height,
        });
      }
    };

    setTimeout(() => {
      updatePosition();
    }, 100);
    window.addEventListener("resize", updatePosition);
    const resizeObserver = new ResizeObserver(updatePosition);
    if (ref?.current) {
      resizeObserver.observe(ref.current);
    }

    return () => {
      window.removeEventListener("resize", updatePosition);
      resizeObserver.disconnect();
    };
  }, [containerWidth]);

  useEffect(() => {
    const root = document.getElementById("landscapPdf");
    if (!root) return;

    const bgImages = new Set();

    // Get all elements inside the PDF section
    const elements = root.querySelectorAll("*");

    elements.forEach((el) => {
      const style = window.getComputedStyle(el);
      const bg = style.backgroundImage;

      if (bg && bg !== "none") {
        // Extract all url(...) values
        const matches = bg.match(/url\((['"]?)(.*?)\1\)/g);

        if (matches) {
          matches.forEach((m) => {
            const url = m.replace(/url\((['"]?)(.*?)\1\)/, "$2");
            bgImages.add(url);
          });
        }
      }
    });

    console.log("Background images found:", [...bgImages]);
  }, []);

  const downloadPdf = async () => {
    const element = document.getElementById("landscapPdf");

    if (!element) {
      console.error("Element #landscapPdf not found");
      return;
    }

    try {
      setLoading(true);
      const startTime = performance.now();

      // Clone element
      const clonedElement = element.cloneNode(true);

      // OPTIMIZE: Remove unnecessary attributes and data
      cleanElement(clonedElement);

      const html = clonedElement.innerHTML;
      const styles = getInlineStyles();
      const baseUrl = window.location.origin;

      // Check payload size
      const payloadSize = new Blob([html]).size;
      console.log(`HTML payload size: ${(payloadSize / 1024).toFixed(2)} KB`);

      if (payloadSize > 100 * 1024 * 1024) {
        // 100MB
        alert("Content too large. Please reduce the size of your layout.");
        return;
      }

      console.log(
        `Preparation took: ${(performance.now() - startTime).toFixed(0)}ms`,
      );
      console.log({
        html: html,
        styles: styles,
        baseUrl: baseUrl,
      });
      const response = await fetch(
        `${process.env.REACT_APP_BACK_URL}/api/pdf`,
        {
          // const response = await fetch("http://localhost:5050/pdf", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            html: html,
            styles: styles,
            baseUrl: baseUrl,
          }),
        },
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Failed to generate PDF");
      }

      const blob = await response.blob();
      console.log("BLOB SIZE: ", blob.size);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `layout-${Date.now()}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      console.log(
        `Total time: ${(performance.now() - startTime).toFixed(0)}ms`,
      );
    } catch (err) {
      console.error("PDF download error:", err);

      if (
        err.message.includes("entity too large") ||
        err.message.includes("PayloadTooLargeError")
      ) {
        alert(
          "The content is too large to generate PDF. Please reduce the size.",
        );
      } else {
        alert("Failed to generate PDF. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  // Clean element to reduce payload size
  function cleanElement(element) {
    // Remove React-specific attributes
    const allElements = element.querySelectorAll("*");
    allElements.forEach((el) => {
      // Remove data attributes added by React/frameworks
      Array.from(el.attributes).forEach((attr) => {
        if (
          attr.name.startsWith("data-react") ||
          attr.name.startsWith("data-testid") ||
          attr.name.startsWith("data-")
        ) {
          el.removeAttribute(attr.name);
        }
      });

      // Remove event listeners (they're useless in PDF)
      el.removeAttribute("onclick");
      el.removeAttribute("onload");
      el.removeAttribute("onerror");
    });

    // Remove script tags (not needed in PDF)
    const scripts = element.querySelectorAll("script");
    scripts.forEach((script) => script.remove());

    // Remove comments
    removeComments(element);

    // Convert inline base64 images to external URLs if possible
    convertBase64ToUrls(element);
  }

  // Remove HTML comments
  function removeComments(element) {
    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_COMMENT,
      null,
      false,
    );

    const comments = [];
    while (walker.nextNode()) {
      comments.push(walker.currentNode);
    }

    comments.forEach((comment) => comment.remove());
  }

  // Convert base64 images back to URLs if they were originally URLs
  function convertBase64ToUrls(element) {
    const images = element.querySelectorAll('img[src^="data:"]');
    images.forEach((img) => {
      // If image has data-original-src, restore it
      const originalSrc = img.getAttribute("data-original-src");
      if (originalSrc) {
        img.src = originalSrc;
        img.removeAttribute("data-original-src");
      }
    });
  }

  // Get inline styles
  function getInlineStyles() {
    const inlineStyles = document.querySelectorAll("style");
    let styles = "";

    inlineStyles.forEach((style) => {
      styles += style.textContent + "\n";
    });

    return styles;
  }

  // Alternative: Compress HTML before sending
  async function compressHtml(html) {
    // Remove extra whitespace
    return html.replace(/\s+/g, " ").replace(/>\s+</g, "><").trim();
  }

  // Normalize URLs (convert absolute to relative if needed)
  function normalizeUrls(element, baseUrl) {
    // Handle images
    const images = element.querySelectorAll("img");
    images.forEach((img) => {
      if (img.src.startsWith(baseUrl)) {
        // Convert absolute URL to relative
        img.src = img.src.replace(baseUrl, "");
      }
      // If already relative or external, leave as is
    });

    // Handle background images in inline styles
    const elementsWithBg = element.querySelectorAll(
      '[style*="background-image"]',
    );
    elementsWithBg.forEach((el) => {
      const style = el.getAttribute("style");
      if (style) {
        const newStyle = style.replace(
          new RegExp(`url\\(['"]?${baseUrl}`, "g"),
          `url('`,
        );
        el.setAttribute("style", newStyle);
      }
    });

    // Handle link tags (CSS files)
    const links = element.querySelectorAll("link[href]");
    links.forEach((link) => {
      if (link.href.startsWith(baseUrl)) {
        link.href = link.href.replace(baseUrl, "");
      }
    });
  }

  // Get inline styles
  function getInlineStyles() {
    const inlineStyles = document.querySelectorAll("style");
    let styles = "";

    inlineStyles.forEach((style) => {
      styles += style.textContent + "\n";
    });

    return styles;
  }

  // Alternative: Keep absolute URLs (even simpler)
  const downloadPdfSimple = async () => {
    const element = document.getElementById("landscapPdf");

    if (!element) {
      console.error("Element #landscapPdf not found");
      return;
    }

    try {
      const response = await fetch("http://localhost:5050/pdf", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          html: element.innerHTML,
          styles: getInlineStyles(),
          baseUrl: window.location.origin,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to generate PDF");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `layout-${Date.now()}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("PDF download error:", err);
      alert("Failed to generate PDF. Please try again.");
    }
  };

  // Helper function to get all relevant styles
  function getAllStyles() {
    const styleSheets = Array.from(document.styleSheets);
    let styles = "";

    styleSheets.forEach((sheet) => {
      try {
        if (sheet.href && !sheet.href.includes(window.location.hostname)) {
          // Skip external stylesheets (like Tailwind CDN)
          return;
        }

        const rules = sheet.cssRules || sheet.rules;
        if (rules) {
          Array.from(rules).forEach((rule) => {
            styles += rule.cssText + "\n";
          });
        }
      } catch (e) {
        // CORS error, skip this stylesheet
        console.warn("Could not access stylesheet:", sheet.href);
      }
    });

    return styles;
  }

  // Helper function to convert images to base64
  async function convertImagesToBase64(element) {
    const images = element.querySelectorAll("img");
    const promises = Array.from(images).map(async (img) => {
      try {
        // Skip if already base64
        if (img.src.startsWith("data:")) {
          return;
        }

        const response = await fetch(img.src);
        const blob = await response.blob();
        const base64 = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });

        img.src = base64;
      } catch (error) {
        console.warn("Failed to convert image to base64:", img.src, error);
      }
    });

    await Promise.all(promises);
  }

  // Update skip button position
  useEffect(() => {
    const updateSkipButtonPosition = () => {
      if (flipBookPosition?.top == 0 && flipBookPosition?.height == 0) return;
      setSkipButtonPosition({
        top:
          (flipBookPosition?.top || 0) + (flipBookPosition?.height || 0) + 20,
        right: 20,
      });
    };

    updateSkipButtonPosition();
  }, [flipBookPosition]);
  // async function searchData(){
  //   try{
  // const {data:{data}} = await axios.get(`${process.env.REACT_APP_API_URL}/presentation/get-presentation/${id}`);
  // if(type === "site"){
  //   data.
  // }
  //   }
  //   catch(e){
  // console.log(e.message);
  //   }
  // }
  const getBaseData = async (projectId) => {
    if (type != "render" && projectId == "6826fe28f13d9ed89b2a732c") return {}; // exception for
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACK_URL}/api/presentation/get-base/${projectId}`,
      );
      return res;
    } catch (error) {
      return {};
    }
  };

  async function getData() {
    const TYPE = {
      render: "render",
      rendered: "render",
      rd: "rd",

      site: "feasibility",
      sf: "feasibility",
      conceptual: "concept",
      cm: "concept",
    };
    try {
      const {
        data: { data },
      } = await axios.get(
        `${process.env.REACT_APP_BACK_URL}/api/presentation/get-presentation-doc/${id}?type=${TYPE[type]}&token=${token}`,
      );
      if (TYPE[type] == "feasibility") {
        console.log("getData", data, convertDataFormat(data));
        setViewData(convertDataFormat(data));
        return;
      }
      if (data?.projectId) {
        const res = await getBaseData(data?.projectId, type);
        // console.log("getBaseData", res?.data);
        let obj = {};
        if (res?.data) {
          obj = {
            companyName: res?.data.data.companyName,
            companyLogo: res?.data.data.companyLogo,
            ...(type == "site"
              ? {
                  siteImage: res?.data.data?.floorMap?.[0]
                    ? res?.data?.data?.floorMap
                    : res?.data.data?.siteImage,
                }
              : { floorMap: res?.data.data.floorMap }),
            // selection1:
            //   res?.data?.data?.selection1 &&
            //   typeof res?.data?.data?.selection1 == "string"
            //     ? JSON.parse(res?.data?.data?.selection1)
            //     : {},
            // selection2:
            //   res?.data?.data?.selection2 &&
            //   typeof res?.data?.data?.selection2 == "string"
            //     ? JSON.parse(res?.data?.data?.selection2)
            //     : {},
            address: res?.data.data.address,
            designStyle: res?.data.data.designStyle,
          };
          // setViewData({ ...data, ...obj });
        }

        setViewData({
          ...data,
          ...obj,
          selection1:
            data?.selection1 && typeof data?.selection1 == "string"
              ? JSON.parse(data?.selection1)
              : {},
          selection2:
            data?.selection2 && typeof data?.selection2 == "string"
              ? JSON.parse(data?.selection2)
              : {},
          selection3:
            data?.selection3 && typeof data?.selection3 == "string"
              ? JSON.parse(data?.selection3)
              : {},
          selection4:
            data?.selection4 && typeof data?.selection4 == "string"
              ? JSON.parse(data?.selection4)
              : {},
        });
      }
    } catch (error) {
      if (
        error?.response?.data?.message == "jwt expired" &&
        error?.response?.status == 500
      ) {
        console.log(error?.response);
        setLinkExp(true);
      }
      console.log(error.message);
    }
  }

  useEffect(() => {
    console.log({ viewData, id });
    if (Object.keys(viewData).length == 0 && id) {
      // searchData();
      getData();
    }
    const t = setTimeout(() => {
      setLoader(false);
    }, 2000);
    return () => clearTimeout(t);
  }, []);
  useEffect(() => {
    if (type == "site") {
      // setTotalPages(
      //   (p) =>
      //     (p || 0) +
      //     Math.ceil(
      //       (viewData?.buildingData?.length || viewData?.formData?.length) +
      //         1 +
      //         flipbookImages.length +
      //         (viewData?.floorMap?.[0] ? 2 : 0)
      //     ) +
      //     1
      // );
    } else if (type == "conceptual") {
      setTotalPages(
        (p) =>
          2 +
          flipbookImages.length +
          (viewData?.layouts?.length ? viewData?.layouts?.length + 1 : 0) +
          getMoodboardArray(viewData?.areas)?.length,
        // p +
        // Math.ceil(
        //   (getMoodboardArray(viewData?.areas)?.length +
        //     1 +
        //     flipbookImages.length +
        //     (viewData?.floorMap?.[0] ? 2 : 0))
        // ) +
        // 1
      ); // areaPage + normal Page
    } else {
      setTotalPages(
        (p) =>
          3 +
          flipbookImages.length +
          (viewData?.layouts?.length ? viewData?.layouts?.length + 1 : 0) +
          viewData?.areas?.length,
        // p +
        // Math.ceil(
        //   (viewData?.areas?.length +
        //     1 +
        //     flipbookImages.length +
        //     (viewData?.floorMap?.[0] ? 2 : 0)) /
        //     (containerWidth <= 1022 ? 1 : 1)
        // ) +
        // 1
      );
    }
  }, [viewData, containerWidth]);

  // if(loader){
  //   return <Loader/>
  // }

  // if (!viewData) {
  //  if(linkExp){
  //   return (
  //   <div className="w-full h-screen bg-black text-teal-500 flex items-center justify-center">
  //     <div className="text-center space-y-6">
  //       {/* Expired Link Icon */}
  //       <div>
  //         <Icon
  //           icon="mdi:link-off"
  //           className="text-teal-400 mx-auto"
  //           width="120"
  //           height="120"
  //         />
  //       </div>

  //       {/* Main Heading */}
  //       <h1 className="text-4xl font-bold text-teal-400">
  //         Link Expired
  //       </h1>

  //       {/* Subheading */}
  //       <p className="text-xl text-teal-300 max-w-md mx-auto">
  //         The link you're trying to access has expired or is no longer valid.
  //       </p>

  //       {/* Additional Info */}
  //       <div className="space-y-2 text-teal-200">
  //         <div className="flex items-center justify-center gap-2">
  //           <Icon icon="mdi:clock-outline" width="20" height="20" />
  //           <span className="text-md">This link has exceeded its time limit</span>
  //         </div>

  //         <div className="flex items-center justify-center gap-2">
  //           <Icon icon="mdi:shield-alert-outline" width="20" height="20" />
  //           <span className="text-md">For security reasons, expired links cannot be accessed</span>
  //         </div>

  //         <div className="flex items-center justify-center gap-2">
  //           <Icon icon="mdi:information-outline" width="20" height="20" />
  //           <span className="text-md">Please request a new link if needed</span>
  //         </div>
  //       </div>

  //       {/* Status Code */}
  //       <div className="mt-4 p-3 border border-teal-500 rounded-md bg-black bg-opacity-30">
  //         <p className="text-sm text-teal-300">
  //           Error Code: 410 - Gone
  //         </p>
  //       </div>
  //     </div>
  //   </div>
  //   )
  //  }
  //   return (
  //       <div className="w-full h-screen bg-black text-teal-500 flex items-center justify-center">
  //     <div className="text-center space-y-6">
  //       {/* Expired Link Icon */}
  //       <div>
  //         <Icon
  //           icon="mdi:link-off"
  //           className="text-teal-400 mx-auto"
  //           width="120"
  //           height="120"
  //         />
  //       </div>

  //       {/* Main Heading */}
  //       <h1 className="text-4xl font-bold text-teal-400">
  //         Invalid Link
  //       </h1>

  //     </div>
  //   </div>
  //   );
  // }
  // console.log(totalPages, currentPage, "----page", viewData);
  let modifiedWidth =
    containerWidth > 1062
      ? Math.min(containerWidth - 60, window.innerHeight * 0.85 * 1.6) //1.6-> 1.77
      : containerWidth - containerWidth / 20;
  if (testView) {
    modifiedWidth += 120;
  }
  const flipbookHeight = getFlipbookHeight(modifiedWidth);
  const minFlipbookWidth =
    // containerWidth/2 -16
    containerWidth < 480
      ? 520
      : containerWidth < 640
        ? 320
        : (modifiedWidth + 4.87) / 2.11;

  // containerWidth < 480 ? 520 : containerWidth < 640 ? 320 : 456;
  console.log(window.innerWidth, "WIDTH +++", {
    containerWidth,
    minFlipbookWidth,
    flipbookHeight,
    modifiedWidth,
    window: window.innerWidth,
    maxW,
    w: containerWidth - 60,
    h: window.innerHeight * 0.85 * 1.6,
  });

  useEffect(() => {
    // getMoodboardArray( viewData?.areas);
  }, [viewData]);

  // useEffect(()=> {
  //   console.log(document.querySelector(".outro-image"))
  // },[currentPage])
  // const VIEWDATA = useMemo
  // console.log({pdfPages})
  console.log("VIEW DATA CHANGED", viewData, state?.data, type, totalPages);
  return (
    <>
      <Loader className={`${loader ? "flex" : "hidden"}`}></Loader>
      {Object.keys(viewData).length == 0 ? (
        <>
          {linkExp ? (
            <div className="w-full h-screen bg-black text-teal-500 flex items-center justify-center">
              <div className="text-center space-y-6">
                {/* Expired Link Icon */}
                <div>
                  <Icon
                    icon="mdi:link-off"
                    className="text-teal-400 mx-auto"
                    width="120"
                    height="120"
                  />
                </div>

                {/* Main Heading */}
                <h1 className="text-4xl font-bold text-teal-400">
                  Link Expired
                </h1>

                {/* Subheading */}
                <p className="text-xl text-teal-300 max-w-md mx-auto">
                  The link you're trying to access has expired or is no longer
                  valid.
                </p>

                {/* Additional Info */}
                <div className="space-y-2 text-teal-200">
                  <div className="flex items-center justify-center gap-2">
                    <Icon icon="mdi:clock-outline" width="20" height="20" />
                    <span className="text-md">
                      This link has exceeded its time limit
                    </span>
                  </div>

                  <div className="flex items-center justify-center gap-2">
                    <Icon
                      icon="mdi:shield-alert-outline"
                      width="20"
                      height="20"
                    />
                    <span className="text-md">
                      For security reasons, expired links cannot be accessed
                    </span>
                  </div>

                  <div className="flex items-center justify-center gap-2">
                    <Icon
                      icon="mdi:information-outline"
                      width="20"
                      height="20"
                    />
                    <span className="text-md">
                      Please request a new link if needed
                    </span>
                  </div>
                </div>

                {/* Status Code */}
                <div className="mt-4 p-3 border border-teal-500 rounded-md bg-black bg-opacity-30">
                  <p className="text-sm text-teal-300">
                    Error Code: 410 - Gone
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className="w-full h-screen bg-black text-teal-500 flex items-center justify-center">
              <div className="text-center space-y-6">
                {/* Expired Link Icon */}
                <div>
                  <Icon
                    icon="mdi:link-off"
                    className="text-teal-400 mx-auto"
                    width="120"
                    height="120"
                  />
                </div>

                {/* Main Heading */}
                <h1 className="text-4xl font-bold text-teal-400">
                  Link has expired <br />
                  please ask for a new link
                </h1>
              </div>
            </div>
          )}
        </>
      ) : (
        <div
          ref={ref}
          style={{
            backgroundImage: `url(${!testView && BG})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundBlendMode: "darken",
          }}
          className={classNames(
            "mx-auto relative w-full   overflow-hidden  ",
            testView ? "h-[85dvh]" : "h-[100dvh] bg-black/30 ",
          )}
        >
          {/* Left Control */}
          <div className="absolute flex  gap-4 z-10 bottom-0 right-0  sm:right-4 sm:top-4  h-fit">
            {IS_INTERNAL && (
              <>
                <ShareButton />
                <Button
                  colorScheme="teal"
                  size={"sm"}
                  key={pdfPages.currentPage}
                  isLoading={loading}
                  // loadingText={`Downloading... (${(Math.floor(pdfPages.currentPage/ pdfPages.totalPage)*100)}%)`}
                  loadingText={
                    type == "site"
                      ? `Downloading... (${Math.floor(
                          (pdfPages.currentPage * 100) / pdfPages.totalPage,
                        )}%)`
                      : "Downloading..."
                  }
                  onClick={type == "site" ? handleDownload : downloadPdf}
                  zIndex={10}
                >
                  Download PDF
                </Button>
              </>
            )}
          </div>
          <button
            disabled={currentPage == 0}
            onClick={goToPrevPage}
            className="absolute left-1/2 -translate-x-1/2 rotate-90 top-[4dvh] w-fit h-fit sm:rotate-0  sm:left-12 sm:top-1/2 transform sm:-translate-y-1/2 z-10 bg-gray-300 bg-opacity-50 hover:bg-opacity-70 text-white p-2 rounded-full transition-all disabled:cursor-not-allowed"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>

          {/* Right Control */}
          <button
            onClick={goToNextPage}
            disabled={currentPage == totalPages - 1}
            className="absolute  left-1/2 -translate-x-1/2 rotate-90 bottom-[4dvh] w-fit h-fit sm:rotate-0 sm:left-auto sm:right-2 sm:top-1/2 transform sm:-translate-y-1/2 z-10 bg-gray-300 bg-opacity-50 hover:bg-opacity-70 text-white p-2 rounded-full transition-all disabled:cursor-not-allowed"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>

          <div
            className={classNames(
              "flex items-center justify-center   h-full mx-auto relative  overflow-hidden ",
              testView ? "w-full " : "w-[95%]",
            )}
          >
            {!testView && (
              <Link to="/home" className="absolute top-4 left-14">
                <ImgOptimized
                  src={Logo192}
                  className="w-[90px] sm:w-[130px] "
                  alt="AirBrick Logo"
                />
              </Link>
            )}
            {(IS_INTERNAL || id == "testing") && !testView && (
              <div className="absolute top-5 -left-0 z-[100]">
                <IconButton
                  colorScheme="blackAlpha"
                  size={"sm"}
                  onClick={() => nav(-1)}
                  icon={
                    <Icon
                      icon={"ion:arrow-back"}
                      color="white"
                      width={"24px"}
                    />
                  }
                />
                {/* <Icon icon={"ion:arrow-back"} color="white" /> */}
              </div>
            )}

            {/* <div className="absolute top-0 "> asdf {Object.keys(viewData).length} {currentPage} {totalPages}</div> */}

            {/* <div className="absolute top-0 left-0 z-[1000] bg-white/30">
            container Width = {containerWidth}, 
             minFlipbookWidth = {minFlipbookWidth},
    flipbookHeight = {flipbookHeight},
    modifiedWidth = {modifiedWidth},
    windowHeight= {window.innerHeight}
            </div> */}

            {type === "site" && (
              <div className="w-full h-full   flex items-center justify-center relative  rotate-90 sm:rotate-0 sm:overflow-hidden ">
                {/* rotate-90 sm:rotate-0 border-2 scale-[1.4] sm:scale-100 */}
                <HTMLFlipBook
                  key={totalPages}
                  ref={flipBookRef}
                  className="w-fit h-fit  "
                  width={containerWidth < 480 ? 520 : modifiedWidth}
                  height={flipbookHeight}
                  minWidth={minFlipbookWidth}
                  // maxHeight={condition/1.77}
                  // height={state?.data ? 1200 : 500}
                  autoSize={true}
                  size="fixed"
                  usePortrait={true}
                  // showCover={true}
                  drawShadow={true}
                  flippingTime={600}
                  useMouseEvents={false}
                  renderOnlyPageLengthChange={true}
                  // className={""}
                >
                  <Page number="1" handleSkipContent={handleSkipContent}>
                    <div className="overflow-hidden h-full relative ">
                      <SitePage01
                        projectName={viewData?.companyName}
                        companyLogo={
                          getImageUrls(
                            [viewData?.companyLogo?.[0]],
                            true,
                            true,
                          )?.[0]
                        }
                      />

                      <CreatedBy
                        username={viewData?.username}
                        date={viewData?.createdAt}
                        className={"bottom-0 -left-3"}
                      />
                    </div>
                  </Page>
                  {beforeImgs.map((v, i) => (
                    <Page number={i + 2} handleSkipContent={handleSkipContent}>
                      <div className="overflow-hidden h-full relative ">
                        <ImgOptimized
                          src={v}
                          alt={`Flipbook Image ${i + 1}`}
                          width="100%"
                          height="100%"
                          className="w-full h-full "
                        />
                        {/* <div
                          className={`absolute ${i==3 ?"bottom-4 right-4 sm:bottom-3 sm:right-6 md:bottom-3 lg:bottom-3  xl:bottom-3 " : "top-4 left-4 sm:top-3 sm:left-6 md:top-3 lg:top-3   xl:top-3 "} flex items-center gap-1`}
                        >
                          <TopAbLogo companyLogo={viewData?.companyLogo?.[0]} isVertical={false} />
                        </div> */}
                        <CreatedBy
                          username={viewData?.username}
                          date={viewData?.createdAt}
                          className={"bottom-0 -left-3"}
                        />
                      </div>
                    </Page>
                  ))}
                  {viewData?.floorMap?.[0] ? (
                    <Page
                      number={1 + beforeImgs.length + 1}
                      handleSkipContent={handleSkipContent}
                    >
                      <div
                        style={{
                          backgroundImage: `url(${layout})`,
                          backgroundSize: "cover",
                        }}
                        className="w-full h-full mr-1 relative"
                      >
                        <CreatedBy
                          username={viewData?.username}
                          date={viewData?.createdAt}
                          className={"bottom-0 -left-3"}
                        />
                      </div>
                    </Page>
                  ) : (
                    <></>
                  )}
                  {viewData?.floorMap?.[0] ? (
                    <Page
                      number={1 + beforeImgs.length + 1 + 1}
                      handleSkipContent={handleSkipContent}
                    >
                      <div
                        style={{
                          backgroundImage: `url(${getOptimizedAssets([
                            layoutBg,
                            layoutBg,
                            layoutBg,
                            layoutBg,
                          ])})`,
                          backgroundSize: "cover",
                        }}
                        className="w-full h-full mx-1"
                      >
                        <div className=" overflow-hidden flex items-center justify-center h-full w-full pb-2 relative">
                          <ImgOptimized
                            src={
                              getImageUrls(
                                [viewData?.floorMap?.[0]],
                                true,
                                true,
                              )?.[0]
                            }
                            alt="Floor Map"
                            className=" max-h-[92.5%] max-w-[64%] w-full h-full object-contain "
                            onLoad={(e) =>
                              console.log(
                                e.target.height,
                                e.target.width,
                                "IMAGE LOADED",
                              )
                            }
                          />
                          <div className="w-24 h-24 md:w-32 md:h-32 xl:w-[15vw] xl:h-[15vw] absolute bottom-4 right-5 border border-gray-300 rounded-full overflow-hidden">
                            <CroppedImageFromFile
                              isLayout={1}
                              imageFile={
                                getImageUrls(
                                  [viewData?.floorMap?.[0]],
                                  true,
                                )?.[0]
                              }
                              areaData={{
                                x: 0,
                                y: 0,
                                width: 0,
                                height: 0,
                              }}
                              position={{
                                x: 0.72413793103453,
                                y: 0.03633171199382,
                              }}
                              radius={100.6206896551724}
                            />
                          </div>
                          <div className="w-24 h-24 md:w-32 md:h-32 xl:w-[15vw] xl:h-[15vw] absolute top-1/3 left-5 border border-gray-300 rounded-full overflow-hidden">
                            <CroppedImageFromFile
                              isLayout={2}
                              imageFile={
                                getImageUrls(
                                  [viewData?.floorMap?.[0]],
                                  true,
                                )?.[0]
                              }
                              areaData={{
                                x: 0,
                                y: 0,
                                width: 0,
                                height: 0,
                              }}
                              position={{
                                x: 401.72413793103453,
                                y: 351.03633171199382,
                              }}
                              radius={88.6206896551724}
                            />
                          </div>
                          <CreatedBy
                            username={viewData?.username}
                            date={viewData?.createdAt}
                            className={"bottom-0 -left-3"}
                          />
                          {/* <Disclamer /> */}
                        </div>
                      </div>
                    </Page>
                  ) : (
                    <></>
                  )}

                  <FormPages
                    backendData={viewData}
                    setTotalPages={(formPage) =>
                      setTotalPages(
                        formPage +
                          2 +
                          flipbookImages.length +
                          (viewData?.floorMap?.[0] ? 2 : 1),
                      )
                    }
                    cWidth={containerWidth < 480 ? 520 : modifiedWidth}
                    number={beforeImgs.length + 4}
                  />

                  {afterImgs.map((v, i) => (
                    <Page
                      number={
                        i +
                        1 +
                        1 +
                        beforeImgs.length +
                        viewData?.buildingData?.length
                      }
                      handleSkipContent={handleSkipContent}
                    >
                      <div className="overflow-hidden h-full relative ">
                        <ImgOptimized
                          src={v}
                          alt={`Flipbook Image ${i + 1}`}
                          width="100%"
                          height="100%"
                          className="w-full h-full "
                        />
                        {/* <div
                          className={`absolute top-4 right-4 sm:top-3 sm:right-6 md:top-3 lg:top-3   xl:top-3 flex items-center gap-1`}
                        >
                          <TopAbLogo companyLogo={viewData?.companyLogo?.[0]} />
                        </div> */}
                        <CreatedBy
                          username={viewData?.username}
                          date={viewData?.createdAt}
                          className={"bottom-0 -left-3"}
                        />
                      </div>
                    </Page>
                  ))}
                  <Page
                    number={
                      beforeImgs.length +
                      viewData?.buildingData?.length +
                      afterImgs.length +
                      2
                    }
                    handleSkipContent={handleSkipContent}
                  >
                    <div className="h-full w-full p-0 relative">
                      <OutroImage isEdged />
                      <CreatedBy
                        username={viewData?.username}
                        date={viewData?.createdAt}
                        className={"bottom-0.5 -left-3"}
                      />
                    </div>
                  </Page>
                </HTMLFlipBook>
              </div>
            )}

            {type == "conceptual" && (
              <div className="w-full h-full    flex items-center flipbook justify-center relative  rotate-90 sm:rotate-0 sm:overflow-hidden  ">
                <HTMLFlipBook
                  key={totalPages}
                  ref={flipBookRef}
                  className="w-fit h-fit  "
                  width={containerWidth < 480 ? 520 : modifiedWidth}
                  height={flipbookHeight}
                  minWidth={minFlipbookWidth}
                  // maxHeight={condition/1.77}
                  // height={state?.data ? 1200 : 500}
                  autoSize={true}
                  size="fixed"
                  usePortrait={true}
                  // showCover={true}
                  drawShadow={true}
                  flippingTime={600}
                  useMouseEvents={false}
                  renderOnlyPageLengthChange={true}
                >
                  <Page number="1" handleSkipContent={handleSkipContent}>
                    <div className=" overflow-hidden h-full relative ">
                      <ConceptualPage01
                        projectName={projectName}
                        companyLogo={
                          getImageUrls(
                            [viewData?.companyLogo?.[0]],
                            true,
                            true,
                          )?.[0]
                        }
                      />
                      <CreatedBy
                        username={viewData?.username}
                        date={viewData?.createdAt}
                        className={"bottom-0 -left-3"}
                      />
                    </div>
                  </Page>
                  {beforeImgs.map((v, i) => (
                    <Page number={i + 2} handleSkipContent={handleSkipContent}>
                      <div className="overflow-hidden h-full relative px-1">
                        <ImgOptimized
                          width="100%"
                          height="100%"
                          src={v}
                          alt={`Flipbook Image ${i + 1}`}
                          className="w-full h-full "
                        />
                        <div
                          className={`absolute ${
                            // i == 3
                            // ? "bottom-2 right-4  sm:bottom-2 lg:bottom-1 xl:bottom-2 sm:right-3 "
                            // :
                            "top-2 left-4  sm:top-2 lg:top-1 xl:top-2 sm:left-3 "
                          }   flex items-center gap-1 `}
                        >
                          {i != 3 && (
                            <TopAbLogo
                              companyLogo={viewData?.companyLogo?.[0]}
                            />
                          )}
                        </div>
                        <CreatedBy
                          username={viewData?.username}
                          date={viewData?.createdAt}
                          className={"bottom-0 -left-2"}
                        />
                      </div>
                    </Page>
                  ))}

                  {(viewData?.layouts || [])?.map((l) => l?.floorMap)?.flat()
                    ?.length > 0 ? (
                    <Page
                      number={1 + beforeImgs.length + 1}
                      handleSkipContent={handleSkipContent}
                    >
                      <div
                        style={{
                          backgroundImage: `url(${layout})`,
                          backgroundSize: "cover",
                        }}
                        className="w-full h-full mr-1 relative"
                      >
                        <CreatedBy
                          username={viewData?.username}
                          date={viewData?.createdAt}
                          className={"bottom-0 -left-3"}
                        />
                      </div>
                    </Page>
                  ) : (
                    <></>
                  )}
                  {(viewData?.layouts || [])?.map((l) => l?.floorMap)?.flat()
                    ?.length > 0 ? (
                    (viewData?.layouts || [])?.map((layout, idx) => (
                      <Page
                        number={1 + beforeImgs.length + 1 + 1 + idx}
                        handleSkipContent={handleSkipContent}
                      >
                        <LayoutSlide
                          layout={layout}
                          viewData={viewData}
                          index={idx + 1}
                        />
                      </Page>
                    ))
                  ) : (
                    <></>
                  )}

                  {getMoodboardArray(viewData?.areas) &&
                    getMoodboardArray(viewData?.areas).map((v, idx) => (
                      // <>
                      <Page
                        number={
                          idx +
                          2 +
                          flipbookImages.length +
                          (viewData?.floorMap?.length > 0 ? 2 : 0)
                        }
                        key={v.area}
                        handleSkipContent={handleSkipContent}
                      >
                        {v?.isDesign ? (
                          <div className=" overflow-hidden h-full px-1 relative">
                            <ImgOptimized
                              src={getOptimizedAssets([
                                designStyle?.find(
                                  (v1) => v?.designStyle == v1.name,
                                )?.slide_Mob,
                                designStyle?.find(
                                  (v1) => v?.designStyle == v1.name,
                                )?.slide_Tab,
                                designStyle?.find(
                                  (v1) => v?.designStyle == v1.name,
                                )?.slide,
                                designStyle?.find(
                                  (v1) => v?.designStyle == v1.name,
                                )?.slide_ExtraLarge,
                              ])}
                              alt="Slide Image"
                              className="w-full h-full"
                            />
                            <ImgOptimized
                              src={watermark}
                              className="absolute top-1/2 opacity-30 -translate-x-1/2 -translate-y-1/2  left-1/2 w-4/5 z-[9999]"
                              alt=""
                            />
                            {/*  <ImgOptimized
                  width="100%"
                  height="100%"
                  src={AbLogo}
                  className="w-12 object-cover z-20 absolute top-4 left-6 "
                /> */}
                            <div
                              className={`absolute top-2 left-4 sm:top-2 sm:left-3  flex items-center gap-1`}
                            >
                              <TopAbLogo
                                companyLogo={viewData?.companyLogo?.[0]}
                              />
                            </div>
                            <CreatedBy
                              username={viewData?.username}
                              date={viewData?.createdAt}
                              className={"bottom-0 -left-2"}
                            />
                          </div>
                        ) : (
                          <div className="w-full h-full px-1 ">
                            <ImgGrid
                              areaName={v.area.area}
                              containerWidth={modifiedWidth}
                              companyLogo={getMinioImage(
                                viewData?.companyLogo?.[0],
                                true,
                              )}
                              floorMap={
                                v?.area?.selectedKeyPlanIdx !== undefined
                                  ? (viewData?.layouts || [])
                                      .map((l) => l.floorMap)
                                      .flat()[v?.area?.selectedKeyPlanIdx]
                                  : null
                              }
                              images={[
                                ...(v.area?.internalImages || []),
                                // ...(v?.designLibraryImages || []),

                                ...getImageUrls(v.area.areaImage, true).map(
                                  (i, idx) => {
                                    if (
                                      v?.area?.areaImageSelection &&
                                      Array.isArray(
                                        v?.area?.areaImageSelection,
                                      ) &&
                                      v?.area?.areaImageSelection?.[idx]
                                    ) {
                                      // console.log({selection : v?.area?.areaImageSelection?.[idx], image: i, idx, newUrl : `${i}${i?.includes("?") ? "&" : "?"}crop=${JSON.stringify(v?.area?.areaImageSelection?.[idx] || {})}`})
                                      return `${i}${i?.includes("?") ? "&" : "?"}crop=${JSON.stringify(v?.area?.areaImageSelection?.[idx] || {})}`;
                                    } else {
                                      return i;
                                    }
                                  },
                                ),
                              ]}
                              coordinates={v.area.keyPlan}
                              isPublicView={true}
                              selectedDesignStyle={
                                v.area?.designStyle || "Warm Industrial"
                              }
                              selectedDesignBg={getDesignBgImage(
                                v?.area.designStyle || "Warm Industrial",
                                v?.area.designBg,
                              )}
                              order={v.area?.order || []}
                              isShowCreatedBy={{
                                username: viewData?.username,
                                date: viewData?.createdAt,
                              }}
                              selection1={v?.area?.selection1}
                              selection2={v?.area?.selection2}
                              selection3={v?.area?.selection3}
                              selection4={v?.area?.selection4}
                            />
                          </div>
                        )}
                      </Page>

                      // </>
                    ))}
                  {afterImgs.map((v, i) => (
                    <Page
                      number={
                        i +
                        1 +
                        (1 +
                          beforeImgs.length +
                          getMoodboardArray(viewData?.areas)?.length)
                      }
                      handleSkipContent={handleSkipContent}
                    >
                      <div className="overflow-hidden h-full relative px-1">
                        <ImgOptimized
                          width="100%"
                          height="100%"
                          src={v}
                          alt={`Flipbook Image ${i + 1}`}
                          className="w-full h-full "
                        />
                        <div
                          className={`absolute top-2 right-3 flex items-center gap-1`}
                        >
                          <TopAbLogo companyLogo={viewData?.companyLogo?.[0]} />
                        </div>
                        <CreatedBy
                          username={viewData?.username}
                          date={viewData?.createdAt}
                          className={"bottom-0 -left-2"}
                        />
                      </div>
                    </Page>
                  ))}
                  <Page
                    number={totalPages}
                    handleSkipContent={handleSkipContent}
                  >
                    <div className="h-full w-full px-1 relative">
                      <OutroImage isEdged />
                      <CreatedBy
                        username={viewData?.username}
                        date={viewData?.createdAt}
                        className={"bottom-1 -left-2"}
                      />
                    </div>
                  </Page>
                </HTMLFlipBook>
              </div>
            )}
            {type == "render" && (
              <div className="w-full h-full   flex items-center justify-center relative  rotate-90 sm:rotate-0 sm:overflow-hidden ">
                <HTMLFlipBook
                  key={totalPages}
                  ref={flipBookRef}
                  className="w-fit h-fit  "
                  width={containerWidth < 480 ? 520 : modifiedWidth}
                  height={flipbookHeight}
                  minWidth={minFlipbookWidth}
                  // maxHeight={condition/1.77}
                  // height={state?.data ? 1200 : 500}
                  autoSize={true}
                  size="fixed"
                  usePortrait={true}
                  // showCover={true}
                  drawShadow={true}
                  flippingTime={600}
                  useMouseEvents={false}
                  renderOnlyPageLengthChange={true}
                >
                  <Page number="1" handleSkipContent={handleSkipContent}>
                    <div className="overflow-hidden h-full relative">
                      <RenderPage01
                        projectName={projectName}
                        companyLogo={getMinioImage(
                          viewData?.companyLogo?.[0],
                          true,
                        )}
                      />
                      <CreatedBy
                        username={viewData?.username}
                        date={viewData?.createdAt}
                        className={"bottom-0 -left-3"}
                      />
                    </div>
                  </Page>
                  {beforeImgs.map((v, i) => (
                    <Page number={i + 2} handleSkipContent={handleSkipContent}>
                      <div className="overflow-hidden h-full relative px-1 ">
                        <ImgOptimized
                          width="100%"
                          height="100%"
                          src={v}
                          alt={`Flipbook Image ${i + 1}`}
                          className="w-full h-full "
                        />
                        <div
                          className={`absolute ${
                            // i == 3
                            // ? " bottom-2 lg:bottom-0.5 2xl:bottom-2 right-4"
                            // :
                            " top-2 lg:top-0.5 2xl:top-2 left-4"
                          } flex items-center gap-1`}
                        >
                          {i != 3 && (
                            <TopAbLogo
                              companyLogo={viewData?.companyLogo?.[0]}
                            />
                          )}
                        </div>
                        <CreatedBy
                          username={viewData?.username}
                          date={viewData?.createdAt}
                          className={"bottom-0 -left-2"}
                        />
                      </div>
                    </Page>
                  ))}
                  {(viewData?.layouts || [])?.map((l) => l?.floorMap)?.flat()
                    ?.length > 0 ? (
                    <Page
                      number={1 + beforeImgs.length + 1}
                      handleSkipContent={handleSkipContent}
                    >
                      <div
                        style={{
                          backgroundImage: `url(${layout})`,
                          backgroundSize: "cover",
                        }}
                        className="w-full h-full mr-1 relative"
                      >
                        <CreatedBy
                          username={viewData?.username}
                          date={viewData?.createdAt}
                          className={"bottom-0 -left-3"}
                        />
                      </div>
                    </Page>
                  ) : (
                    <></>
                  )}
                  {(viewData?.layouts || [])?.map((l) => l?.floorMap)?.flat()
                    ?.length > 0 ? (
                    (viewData?.layouts || [])?.map((layout, idx) => (
                      <Page
                        number={1 + beforeImgs.length + 1 + 1 + idx}
                        handleSkipContent={handleSkipContent}
                      >
                        <LayoutSlide
                          layout={layout}
                          viewData={viewData}
                          index={idx + 1}
                        />
                      </Page>
                    ))
                  ) : (
                    <></>
                  )}

                  <Page
                    number={2 + flipbookImages.length}
                    handleSkipContent={handleSkipContent}
                  >
                    <div
                      style={{
                        backgroundImage: `url(${renderHeadingSlide})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                      }}
                      className="w-full h-full relative"
                    >
                      <CreatedBy
                        username={viewData?.username}
                        date={viewData?.createdAt}
                        className={"bottom-0 -left-3"}
                      />
                    </div>
                  </Page>
                  {viewData?.areas &&
                    viewData?.areas?.map((v, idx) => (
                      <Page
                        number={idx + 3 + flipbookImages.length}
                        key={v.area}
                        handleSkipContent={handleSkipContent}
                      >
                        <div className="w-full h-full px-1">
                          <ThreeDPanel
                            companyLogo={viewData?.companyLogo?.[0]}
                            floorMap={
                              v?.selectedKeyPlanIdx !== undefined
                                ? (viewData?.layouts || [])
                                    .map((l) => {
                                      return l.floorMap;
                                    })
                                    .flat()[v?.selectedKeyPlanIdx]
                                : null
                            }
                            details={v}
                            isPublicView={true}
                            isShowCreatedBy={{
                              username: viewData?.username,
                              date: viewData?.createdAt,
                            }}
                          />
                        </div>
                      </Page>
                    ))}
                  {afterImgs.map((v, i) => (
                    <Page
                      number={
                        i +
                        1 +
                        (1 + beforeImgs.length + viewData?.areas?.length)
                      }
                      handleSkipContent={handleSkipContent}
                    >
                      <div className="overflow-hidden h-full relative px-1">
                        <ImgOptimized
                          width="100%"
                          height="100%"
                          src={v}
                          alt={`Flipbook Image ${i + 1}`}
                          className="w-full h-full "
                        />
                        <div
                          className={`absolute top-2 lg:top-0.5 2xl:top-2 right-4 flex items-center gap-1`}
                        >
                          <TopAbLogo companyLogo={viewData?.companyLogo?.[0]} />
                        </div>
                        <CreatedBy
                          username={viewData?.username}
                          date={viewData?.createdAt}
                          className={"bottom-0 -left-2"}
                        />
                      </div>
                    </Page>
                  ))}
                  <Page
                    number={totalPages}
                    handleSkipContent={handleSkipContent}
                  >
                    <div className="h-full w-full  relative">
                      <OutroImage isEdged />
                      <CreatedBy
                        username={viewData?.username}
                        date={viewData?.createdAt}
                        className={"bottom-0.5 -left-3"}
                      />
                    </div>
                  </Page>
                </HTMLFlipBook>
              </div>
            )}
          </div>
          {IS_INTERNAL && (
            <PdfContent
              renderData={viewData}
              type={type}
              projectName={projectName}
              beforeImgs={beforeImgs}
              afterImgs={afterImgs}
              modifiedWidth={modifiedWidth}
            />
          )}
        </div>
      )}

      {/* <div
        className="fixed z-[100]"
        style={{
          top: skipButtonPosition.top,
          right: skipButtonPosition.right,
        }}
      >
        <button
          onClick={handleSkipContent}
          className="cursor-pointer text-gray-300 underlin"
        >
          Skip to content
        </button>
      </div> */}
    </>
  );
};

export const Page = React.forwardRef((props, ref) => {
  return (
    <div className="demoPage h-full  w-full shadow-sm relative " ref={ref}>
      {/* <> */}
      {props.children}
      {/* </> */}
      <div
        className="absolute right-0 -bottom-6 z-[1000]"
        // style={{
        //   top: skipButtonPosition.top,
        //   right: skipButtonPosition.right,
        // }}
      >
        <button
          onClick={
            props?.handleSkipContent ? props.handleSkipContent : () => {}
          }
          className="cursor-pointer text-gray-300 hover:underline text-sm"
        >
          Skip to content
        </button>
      </div>
    </div>
  );
});

const PdfContent = ({
  type,
  renderData,
  projectName,
  beforeImgs,
  afterImgs,
  modifiedWidth,
}) => {
  let viewData = renderData;
  const [base64, setBase64] = useState({
    floorMap: "",
  });
  useEffect(() => {
    if (renderData?.floorMap?.[0]) {
      getBase64ImageFromUrl(
        getImageUrls([renderData?.floorMap?.[0]], true)?.[0],
      ).then((base64) => {
        setBase64((prev) => ({
          ...prev,
          floorMap: base64,
        }));
      });
    }
  }, [renderData?.floorMap?.[0]]);
  if (type == "site") {
    return (
      <div id="landscapPdf" className="opacity-0 pointer-events-none">
        <div
          style={{
            backgroundImage: `url(${siteIntro})`,
            // backgroundSize: "contain",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",

            backgroundPosition: "left ",
            width: "100%",
            height: "100%",
          }}
          className="h-full pdfSection section1 w-full  bg-white-300  relative"
        >
          {/* <div className="absolute  w-[480px] h-[140px] bottom-[205px] left-[70px] flex items-center justify-center   ">
            <div className="text-7xl text-white font-semibold  text-center">
              {projectName}
            </div>
          </div> */}
          <LogoPlacement
            projectName={projectName}
            companyLogo={getMinioImage(renderData?.companyLogo?.[0], true)}
            isPdf={true}
          />
          <CreatedBy
            username={renderData?.username}
            date={renderData?.createdAt}
            className={"bottom-0 -left-2"}
            isPdf={true}
          />
        </div>
        {beforeImgs.map((v, i) => (
          <div className="  overflow-hidden h-full pdfSection section3 relative">
            <ImgOptimized
              src={v}
              alt={`Flipbook Image ${i + 1}`}
              className="w-full h-full "
            />
            {/* <div className={`absolute top-4 left-4 flex items-center gap-1`}>
              <TopAbLogo
                companyLogo={renderData?.companyLogo?.[0]}
                isPdf={true}
              />
            </div> */}
            <CreatedBy
              username={viewData?.username}
              date={viewData?.createdAt}
              isPdf={true}
            />
          </div>
        ))}
        {viewData?.floorMap?.[0] && (
          <div className="pdfSection section2 w-full h-full bg-white">
            <div
              style={{
                backgroundImage: `url(${layout})`,
                backgroundSize: "cover",
              }}
              className="w-full h-full mr-1"
            ></div>
          </div>
        )}
        {viewData?.floorMap?.[0] && (
          <div className="pdfSection section2 w-full h-full bg-white relative">
            <div
              style={{
                backgroundImage: `url(${layoutBg})`,
                backgroundSize: "cover",
              }}
              className="w-full h-full mx-1"
            >
              <div className=" overflow-hidden flex items-center justify-center pb-4 h-full w-full">
                <ImgOptimized
                  src={base64.floorMap}
                  alt="Floor Map"
                  className="max-h-[92.5%] max-w-[64%] w-full h-full object-contain  "
                />
              </div>
              <div className="w-[180px] h-[180px] absolute bottom-4 right-5 border border-gray-300 rounded-full overflow-hidden">
                <CroppedImageFromFile
                  isLayout={1}
                  imageFile={base64.floorMap}
                  areaData={{
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0,
                  }}
                  position={{
                    x: 0.72413793103453,
                    y: 0.03633171199382,
                  }}
                  radius={100.6206896551724}
                />
              </div>
              <div className="w-[180px] h-[180px] absolute top-1/3 left-5 border border-gray-300 rounded-full overflow-hidden">
                <CroppedImageFromFile
                  isLayout={2}
                  imageFile={base64.floorMap}
                  areaData={{
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0,
                  }}
                  position={{
                    x: 401.72413793103453,
                    y: 351.03633171199382,
                  }}
                  radius={88.6206896551724}
                />
              </div>
            </div>
            {/* <Disclamer /> */}
          </div>
        )}

        <FormPages
          setTotalPages={() => {}}
          backendData={renderData}
          cWidth={modifiedWidth}
          isPdf={true}

          // number={beforeImgs.length + 4}
        />
        {/* {renderData?.buildingData?.map((area, idx) => (
          <div
            key={idx}
            className="pdfSection section2 w-full h-full bg-white "
          >
            <ViewPageSite
              isPdfContent={true}
              isPublicView={true}
              key={idx}
              companyLogo={renderData?.companyLogo?.[0]}
              floorMap={renderData?.siteImage?.[0] || renderData?.floorMap?.[0]}
              data={area}
              isShowCreatedBy={{
                username: viewData?.username,
                date: viewData?.createdAt,
                isPdf: true,
              }}
            />
          </div>
        ))} */}

        {afterImgs.map((v, i) => (
          <div className="  overflow-hidden h-full pdfSection section4 relative">
            <ImgOptimized
              src={v}
              alt={`Flipbook Image ${i + 1}`}
              className="w-full h-full "
            />
            {/* <div className={`absolute top-4 right-4 flex items-center gap-1 `}>
              <TopAbLogo
                companyLogo={renderData?.companyLogo?.[0]}
                isPdf={true}
              />
            </div> */}
            <CreatedBy
              username={viewData?.username}
              isPdf={true}
              date={viewData?.createdAt}
            />
          </div>
        ))}
        <div className="h-full pdfSection  relative">
          <OutroImage isEdged={true} />
          <CreatedBy
            username={viewData?.username}
            date={viewData?.createdAt}
            isPdf={true}
          />
        </div>
      </div>
    );
  }
  if (type == "render") {
    return (
      <div id="landscapPdf" className="opacity-0 pointer-events-none">
        {/* introPage */}

        <div
          style={{
            backgroundImage: `url(${intro})`,
            // backgroundSize: "contain",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",

            backgroundPosition: "center",
            width: "100vw",
            height: "100vh",
          }}
          className="h-full pdfSection section1 w-full  bg-cyan-300  relative"
        >
          {/* <div className="absolute  w-[470px] h-[120px] bottom-[130px] left-1/2 -translate-x-1/2 flex items-center justify-center   ">
            <div className="text-7xl text-white font-semibold  text-center">
              {projectName}
            </div>
          </div> */}
          <LogoPlacement
            projectName={projectName}
            companyLogo={getMinioImage(renderData?.companyLogo?.[0], true)}
            isPdf={false}
          />
          <CreatedBy
            username={viewData?.username}
            date={viewData?.createdAt}
            className={"bottom-0 -left-2"}
            isPdf={true}
          />
        </div>
        {beforeImgs.map((v, i) => (
          <div className="  overflow-hidden h-[100svh] pdfSection section3 relative">
            <ImgOptimized
              src={v}
              alt={`Flipbook Image ${i + 1}`}
              className="w-full h-full "
            />
            {i != 3 && (
              <div className={`absolute top-4 left-4 flex items-center gap-1`}>
                <TopAbLogo
                  companyLogo={renderData?.companyLogo?.[0]}
                  isPdf={true}
                />
              </div>
            )}
            <CreatedBy
              username={viewData?.username}
              date={viewData?.createdAt}
              className={"bottom-0 -left-2"}
              isPdf={true}
            />
          </div>
        ))}
        {(viewData?.layouts || [])?.map((l) => l?.floorMap)?.flat()?.length >
          0 && (
          <div className="pdfSection section2 w-full  h-[100svh] bg-white">
            <div
              style={{
                backgroundImage: `url(${layout})`,
                backgroundSize: "cover",
              }}
              className="w-[100svw] h-full mr-1"
            >
              <img src={layout} className="w-full h-full object-cover" />
            </div>
          </div>
        )}

        {(viewData?.layouts || [])?.map((l) => l?.floorMap)?.flat()?.length >
          0 &&
          (viewData?.layouts || [])?.map((layout, idx) => (
            <div className="pdfSection section2 w-full h-[100svh] bg-white relative">
              {/* <Page number={1 + beforeImgs.length + 1 + 1 + idx}> */}
              <LayoutSlide
                layout={layout}
                viewData={viewData}
                index={idx + 1}
                isPdf={false}
              />
              {/* </Page> */}
              <Disclamer />
            </div>
          ))}

        <div>
          <div
            style={{
              backgroundImage: `url(${renderHeadingSlide})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
            className="w-[100svw] h-[100svh] relative pdfSection"
          >
            <CreatedBy
              username={viewData?.username}
              date={viewData?.createdAt}
              isPdf={true}
              className={"bottom-0 -left-3"}
            />
          </div>
          {renderData?.areas &&
            renderData?.areas?.map((area) => (
              <div
                key={area.area}
                className="pdfSection section2 w-full h-full bg-white p-"
              >
                <ThreeDPanel
                  companyLogo={renderData?.companyLogo?.[0]}
                  // floorMap={renderData?.floorMap?.[0]}
                  floorMap={
                    area?.selectedKeyPlanIdx !== undefined
                      ? (renderData?.layouts || [])
                          .map((l) => {
                            return l.floorMap;
                          })
                          .flat()[area?.selectedKeyPlanIdx]
                      : null
                  }
                  details={area}
                  isPublicView={true}
                  isPdfView={false}
                  isPdf={true}
                  isShowCreatedBy={{
                    username: viewData?.username,
                    date: viewData?.createdAt,
                    isPdf: false,
                  }}
                />
              </div>
            ))}
        </div>
        {afterImgs.map((v, i) => (
          <div className="  overflow-hidden h-full pdfSection section3 relative">
            <ImgOptimized
              src={v}
              alt={`Flipbook Image ${i + 1}`}
              className="w-full h-full "
            />
            <div className={`absolute top-4 right-4 flex items-center gap-1`}>
              <TopAbLogo
                companyLogo={renderData?.companyLogo?.[0]}
                isPdf={true}
              />
            </div>
            <CreatedBy
              username={viewData?.username}
              date={viewData?.createdAt}
              className={"bottom-0 -left-2"}
              isPdf={true}
            />
          </div>
        ))}
        <div className="h-full pdfSection  relative">
          <OutroImage isEdged={true} />
          <CreatedBy
            username={viewData?.username}
            date={viewData?.createdAt}
            className={"bottom-0 -left-2"}
            isPdf={true}
          />
        </div>
      </div>
    );
  }
  if (type == "conceptual") {
    return (
      <div id="landscapPdf" className="opacity-0 pointer-events-none">
        {/* introPage */}

        <div
          style={{
            backgroundImage: `url(${intro})`,
            // backgroundSize: "contain",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",

            backgroundPosition: "center ",
            width: "100%",
            height: "100%",
          }}
          className="min-h-[100svh] pdfSection section1 w-full  bg-gray-100  relative"
        >
          {/* <div className="absolute  w-[470px] h-[120px] bottom-[130px] left-1/2 -translate-x-1/2 flex items-center justify-center   ">
            <div className="text-7xl text-white font-semibold  text-center">
              {projectName}
            </div>
          </div> */}
          <LogoPlacement
            projectName={projectName}
            companyLogo={getMinioImage(renderData?.companyLogo?.[0], true)}
            isPdf={false}
          />
          <CreatedBy
            username={viewData?.username}
            date={viewData?.createdAt}
            className={"bottom-0 -left-2"}
            isPdf={true}
          />
        </div>
        {beforeImgs.map((v, i) => (
          <div className="  overflow-hidden h-[100svh] w-full  pdfSection section3 relative">
            <ImgOptimized
              src={v}
              alt={`Flipbook Image ${i + 1}`}
              className="w-full h-full "
            />
            {i != 3 && (
              <div className={`absolute top-4 left-4 flex items-center gap-1`}>
                <TopAbLogo
                  companyLogo={renderData?.companyLogo?.[0]}
                  isPdf={true}
                />
              </div>
            )}
            <CreatedBy
              username={viewData?.username}
              date={viewData?.createdAt}
              className={"bottom-0 -left-2"}
              isPdf={true}
            />
          </div>
        ))}

        {(renderData?.layouts || [])?.map((l) => l?.floorMap)?.flat()?.length >
          0 && (
          <div className="pdfSection section2 w-full h-[100svh] bg-white">
            <div
              style={{
                backgroundImage: `url(${layout})`,
                backgroundSize: "cover",
              }}
              className="w-full h-full "
            >
              <img src={layout} className="w-full h-full object-cover" />
            </div>
          </div>
        )}

        {(renderData?.layouts || [])?.map((l) => l?.floorMap)?.flat()?.length >
          0 &&
          (renderData?.layouts || [])?.map((layout, idx) => (
            <div className="pdfSection section2 w-full h-[100svh] bg-white relative">
              <LayoutSlide
                layout={layout}
                viewData={renderData}
                index={idx + 1}
                isPdf={false}
              />
            </div>
          ))}
        {/* <Disclamer /> */}

        <div>
          {renderData.areas &&
            getMoodboardArray(renderData.areas)?.map((v, idx) => (
              <>
                {v?.isDesign ? (
                  <div className="pdfSection overflow-hidden h-[100svh] relative">
                    <ImgOptimized
                      src={
                        designStyle?.find((v1) => v?.designStyle == v1.name)
                          ?.slide
                      }
                      className="w-full h-full object-cover"
                    />
                    <ImgOptimized
                      src={watermark}
                      className="absolute top-1/2 opacity-30 -translate-x-1/2 -translate-y-1/2  left-1/2 w-4/5 z-[9999]"
                      alt=""
                    />
                    <CreatedBy
                      username={viewData?.username}
                      date={viewData?.createdAt}
                      className={"bottom-0 -left-2"}
                      isPdf={true}
                    />
                  </div>
                ) : (
                  <div
                    className="pdfSection section2 w-full h-[100svh] bg-white "
                    key={v.area}
                  >
                    <ImgGrid
                      areaName={v.area.area}
                      containerWidth={modifiedWidth}
                      companyLogo={getMinioImage(
                        renderData.companyLogo?.[0],
                        true,
                      )}
                      floorMap={
                        v?.area?.selectedKeyPlanIdx !== undefined
                          ? (renderData?.layouts || [])
                              .map((l) => l.floorMap)
                              .flat()[v?.area?.selectedKeyPlanIdx]
                          : null
                      }
                      order={v.area?.order || []}
                      images={[
                        ...(v.area?.internalImages || []),
                        // ...(v?.designLibraryImages || v?.internalImages   || []),
                        ...getImageUrls(v.area.areaImage, true, true),
                      ]}
                      coordinates={v.area.keyPlan}
                      isPublicView={true}
                      isPdfView={false}
                      isPdf={true}
                      selectedDesignStyle={v.area?.designStyle}
                      selectedDesignBg={getDesignBgImage(
                        v?.area.designStyle || "Warm Industrial",
                        v?.area.designBg,
                      )}
                      selection1={v?.area?.selection1}
                      selection2={v?.area?.selection2}
                      selection3={v?.area?.selection3}
                      selection4={v?.area?.selection4}
                      isShowCreatedBy={{
                        username: viewData?.username,
                        date: viewData?.createdAt,
                        isPdf: false,
                      }}
                    />
                  </div>
                )}
              </>
            ))}
        </div>
        {afterImgs.map((v, i) => (
          <div className="  overflow-hidden h-[100svh] pdfSection section3 relative">
            <ImgOptimized
              src={v}
              alt={`Flipbook Image ${i + 1}`}
              className="w-full h-full "
            />
            <CreatedBy
              username={viewData?.username}
              date={viewData?.createdAt}
              className={"bottom-0 -left-2"}
              isPdf={true}
            />
            <div className={`absolute top-4 right-4 flex items-center gap-1`}>
              <TopAbLogo
                companyLogo={renderData?.companyLogo?.[0]}
                isPdf={true}
              />
            </div>
          </div>
        ))}
        <div className="h-[100svh] pdfSection relative ">
          <OutroImage isEdged={true} />
          <CreatedBy
            username={viewData?.username}
            date={viewData?.createdAt}
            className={"bottom-0 -left-2"}
            isPdf={true}
          />
        </div>
      </div>
    );
  }
  return (
    <div id="landscapPdf" className="opacity-0 pointer-events-none">
      {/* introPage */}
      INVALID Page
    </div>
  );
};

export const CreatedBy = ({ username, date, className, isPdf }) => {
  // console.log("CREATED BY", { username, date, className, isPdf });
  return (
    <div
      style={{ ...(isPdf && { bottom: "2px", left: "-12px" }) }}
      className={`absolute  px-2 w-fit ${
        className ? className : "bottom-2 left-0"
      }  z-[100] `}
    >
      <div
        className={` w-fit bg-black/30 relative left-1 text-gray-200 ${
          isPdf ? "p-1 px-2 text-xs" : "px-2 text-[10px]"
        }    `}
      >
        <>
          {/* {isPdf ? (
            <span className="relative bottom-2 text-xs">
              Created by : {username}{" "} on{" "}
              {date && moment(date).format("DD MMM YYYY ")}
            </span>
          ) : ( */}
          <>
            Created by : {username} on{" "}
            {date && moment(date).format("DD MMM YYYY ")}
          </>
          {/* )} */}
        </>
      </div>
    </div>
  );
};

export default PublicViewRender;

//  <Page number={1 + flipbookImages.length + 1}>
//             <div className=" overflow-hidden h-full px-1 relative">
//                <ImgOptimized
//                 src={
//                   designStyle?.find((v) => viewData?.designStyle == v.name)
//                     ?.slide || ""
//                 }
//                 alt="Slide Image"
//                 className="w-full h-full"
//               />
//                <ImgOptimized
//                 src={watermark}
//                 className="absolute top-1/2 opacity-50 -translate-x-1/2 -translate-y-1/2  left-1/2 w-4/5 z-[9999]"
//                 alt=""
//               />
//               {/*  <ImgOptimized
//                 width="100%"
//                 height="100%"
//                 src={AbLogo}
//                 className="w-12 object-cover z-20 absolute top-4 left-6 "
//               /> */}
//                 <div
//                   className={`absolute top-2 left-4 sm:top-2 sm:left-3  flex items-center gap-1`}
//                 >
//                   <TopAbLogo companyLogo={viewData?.companyLogo?.[0]} />
//                 </div>
//               <CreatedBy
//                 username={viewData?.username}
//                 date={viewData?.createdAt}
//                 className={"bottom-1 -left-2"}
//               />
//             </div>
//           </Page>
